type SessionEndListener = () => void;

const listeners = new Set<SessionEndListener>();

/**
 *	Runs `listener` when the user logs out, before the token is cleared,
 *	for state that must not outlive the login it was made under, such as
 *	queued saves that would otherwise go out as whoever logs in next.
 *	Returns the unsubscribe.
 */
export function onSessionEnd(listener: SessionEndListener): () => void {
	listeners.add(listener);

	return () => listeners.delete(listener);
}

/** Called by logout. */
export function endSession(): void {
	for (const listener of listeners) {
		listener();
	}
}
